import NextImage from "next/image";
import NextLink from "next/link";

import { formatDate } from "@releaseit/utils-formatters";

import { BlogPost } from "../../types";

export type BlogCardProps = {
  blog: BlogPost;
};

export function BlogCard({ blog }: BlogCardProps) {
  return (
    <NextLink href={`/blog/${blog.UrlSlug}`}>
      <a className="flex flex-col overflow-hidden rounded-lg border border-gray-100 bg-white transition hover:-translate-y-1 hover:shadow-card">
        <div className="aspect-w-4 aspect-h-3 relative">
          <NextImage
            src={blog.HeroImage.formats.medium.url}
            alt={blog.Heading}
            layout="fill"
            sizes="640px"
            priority
            className="object-cover"
          />
        </div>

        <div className="flex grow flex-col p-4">
          <h2 className="truncate text-lg font-medium">{blog.Heading}</h2>
          <p className="mt-2 grow overflow-hidden text-gray-800 [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2]">
            {blog.Blurb}
          </p>
          <p className="mt-4 text-sm italic text-gray-700">
            {formatDate(new Date(blog.published_at), "long")}
          </p>
        </div>
      </a>
    </NextLink>
  );
}
